var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonMaticLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 489.8 489.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 123.7,
    x2: 374.78,
    y1: 1831.36,
    y2: 1648.28,
    gradientTransform: "translate(0 -1498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a726c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#803bdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b3fe4"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 244.9,
    cy: 244.9,
    r: 244.9,
    style: {
      fill: "#f5f0fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.7 297.8 69.3-40c3.7-2.1 5.9-6.1 5.9-10.3v-80c0-4.2-2.3-8.2-5.9-10.3l-69.3-40c-3.7-2.1-8.2-2.1-11.9 0l-69.3 40c-3.7 2.1-5.9 6.1-5.9 10.3v143l-48.6 28-48.6-28v-56.1l48.6-28.1 32.1 18.5v-37.6L186 192.1c-1.8-1-3.9-1.6-5.9-1.6s-4.1.6-5.9 1.6l-69.3 40c-3.7 2.1-5.9 6.1-5.9 10.3v80c0 4.2 2.3 8.2 5.9 10.3l69.3 40c3.7 2.1 8.2 2.1 11.9 0l69.3-40c3.7-2.1 5.9-6.1 5.9-10.3v-143l.9-.5 47.7-27.6 48.6 28.1v56.1l-48.6 28-32-18.5v37.6l26.1 15c3.5 2.3 8.1 2.3 11.7.2Z",
    style: {
      fill: "url(#a)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonMaticLogo);
export default __webpack_public_path__ + "static/media/polygon-matic-logo.8b2106a97a95b76b2b5ef39368fa03ce.svg";
export { ForwardRef as ReactComponent };